import styled from 'styled-components';
import { StyledAdminListRow } from '../../AdminListHeaderCell/styles/StyledAdminListRow';

export const StyledAdminPaymentHistoryListRow = styled.div`
  ${StyledAdminListRow}

  .admin-list-cell-container {
    &.id,
    &.status,
    &.createdat,
    &.updatedat {
      flex-basis: initial;
      flex-grow: 0;
    }
    &.id {
      width: 10.4rem;
    }
    &.status {
      width: 14.4rem;
    }
    &.createdat,
    &.updatedat {
      width: 23.8rem;
    }
  }

  .status-select {
    background: ${({ theme }) => theme.bg3};
    color: ${({ theme }) => theme.text1};
    border: 1px solid ${({ theme }) => theme.stroke2};
    border-radius: 6px;
    padding: 4px 8px;
    font-size: 12px;
    cursor: pointer;
  }

  .status-select:hover {
    border-color: ${({ theme }) => theme.accent2};
  }
`;